import React, { useState, useEffect, useContext } from 'react';
import { Container, IconButton, Box, Button } from '@mui/material';
import DataTable from '../components/DataTable';
import PageTitle from '../components/PageTitle';
import { useConfirm } from '../assets/contexts/confirmContext';
import { useNotification } from '../assets/contexts/notificationContext';
import { UserContext } from '../assets/contexts/userContext';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import * as endPoints from '../assets/js/endpoints';
import { useNavigate } from 'react-router-dom';
import { ACTION_ICON_COLORS } from '../constants/iconActionColors';
import AddIcon from '@mui/icons-material/Add';
import { Helmet } from 'react-helmet';

const EmployeeForms = () => {
  const { user } = useContext(UserContext);
  const [forms, setForms] = useState([]);
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { showNotification } = useNotification();

  const fetchForms = async () => {

    if (!user.id) return;
    try {
      const data = await endPoints.getFormsUserCanView(user.id);
      const list = Array.isArray(data) ? data : data.data;
      setForms(list);
    } catch (error) {
      showNotification('Error al obtener formularios', 'error');
    }
  };

  useEffect(() => {
    fetchForms();
//     if (user.id !== null) fetchForms();
  }, [user.id]);

  const handleDelete = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    const ok = await confirm('¿Eliminar formulario?');
    if (!ok) return;
    try {
      await endPoints.deleteForm(id);
      fetchForms();
      showNotification('Formulario eliminado', 'success');
    } catch (error) {
      showNotification('Error eliminando formulario', 'error');
    }
  };


  const handleEdit = id => {
    navigate(`/pages/createForm/${id}`);
  };

  const handleCreate = () => {
    navigate('/pages/createForm');
  };


  const columns = [
    { id: 'nombre', label: 'Nombre' },
    { id: 'tipo', label: 'Tipo' },
     { id: 'respuestas', label: 'Respuestas', sortable: false }
  ];

  const rows = forms.map(f => ({
  ...f,
  tipo: f.form_type?.name,
  respuestas: (
    <Button
      onClick={() => navigate(`/employee/forms/formResponses/${f.id}`)}
      startIcon={<ListAltIcon />}
      aria-label="Ver respuestas"
      sx={{ color: ACTION_ICON_COLORS.see }}
    >
      Ver respuestas
    </Button>
  )
}));

  const actions = form => {
    const canManage = user.hasRole('admin') || form.user_id === user.id;
    if (!canManage) return null;
    return (
      <>
        <IconButton
          onClick={() => handleEdit(form.id)}
          sx={{ color: ACTION_ICON_COLORS.edit }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          onClick={e => handleDelete(e, form.id)}
          sx={{ color: ACTION_ICON_COLORS.delete }}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };

  return (
    <>
      <Helmet>
        <title>Mis Formularios | CES</title>
      </Helmet>
      <Container sx={{ mt: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <PageTitle>Mis Formularios</PageTitle>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreate}>Crear Nuevo Formulario</Button>
        </Box>
        <DataTable columns={columns} rows={rows} actions={actions} />
      </Container>
    </>
  );
};

export default EmployeeForms;
